import { render, staticRenderFns } from "./SchoolJob.vue?vue&type=template&id=32cd901e&"
import script from "./SchoolJob.vue?vue&type=script&lang=js&"
export * from "./SchoolJob.vue?vue&type=script&lang=js&"
import style0 from "./SchoolJob.vue?vue&type=style&index=0&id=32cd901e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports